module.exports = __webpack_public_path__ + "static/media/plan-C1b-desktop-en.6257f7fc.png";